import { FORBIDDEN_FILE_UPLOAD_TYPES } from "repoV2/features/Common/modules/Files/Files.constants";

/**
 * @deprecated Please use the constant at repoV2/features/Common/constants/files.ts
 */
export const forbiddenFileUploadTypes = FORBIDDEN_FILE_UPLOAD_TYPES;
